<template>
  <div class='contentPadding'>
      <a-form layout="inline">
          <a-form-item label="bean">
              <a-input
                placeholder="请输入bean名称"
                v-model:value="searchform.beanName"
                allow-clear
                />
          </a-form-item>
          <a-form-item>
            <a-button
            type="primary"
            @click="onSearch"
            v-if="isShowBtn('sys:schedule:list')"
            >
            查询
            </a-button>
            <a-button
            @click="reset"
            v-if="isShowBtn('sys:schedule:list')"
            style="margin-left:10px"
            >
            重置
            </a-button>
        </a-form-item>
      </a-form>
      <a-row class="buttonGroup">
      <a-button type="primary" class="btnMargin" @click="toAdd">
        <PlusOutlined />新建
      </a-button>
      <a-button class="btnMargin" v-if="isShowBtn('sys:schedule:delete')" @click="del(selectedRowKeys)" :disabled="selectedRowKeys.length==0">
        批量删除
      </a-button>
      <a-button class="btnMargin" v-if="isShowBtn('sys:schedule:pause')" @click="pause(selectedRowKeys)" :disabled="selectedRowKeys.length==0">
        批量暂停
      </a-button>
      <a-button class="btnMargin" v-if="isShowBtn('sys:schedule:resume')" @click="resume(selectedRowKeys)" :disabled="selectedRowKeys.length==0">
        批量恢复
      </a-button>
      <a-button class="btnMargin" v-if="isShowBtn('sys:schedule:run')" @click="run(selectedRowKeys)" :disabled="selectedRowKeys.length==0">
        批量立即执行
      </a-button>
      <a-button class="btnMargin" v-if="isShowBtn('sys:schedule:log')" @click="toLog">
        日志列表
      </a-button>
    </a-row>
    <a-table
      :row-selection="rowSelection"
      :data-source="schedulelist"
      row-key="jobId"
      :pagination="false"
    :scroll="{y: 650 }"

    >
    <a-table-column
        key="jobId"
        title="ID"
        data-index="jobId"
        align="center"
      />
      <a-table-column
        key="beanName"
        title="bean名称"
        data-index="beanName"
        align="center"
      />
      <a-table-column
        key="params"
        title="参数"
        data-index="params"
        align="center"
      />
      <a-table-column
        key="cronExpression"
        title="cron表达式"
        data-index="cronExpression"
        align="center"
      />
      <a-table-column
        key="remark"
        title="备注"
        data-index="remark"
        align="center"
      />
      <a-table-column
        key="status"
        title="状态"
        align="center"
      >
      <template v-slot="scope">
        <span>
          <a-tag v-if="scope.text.status==0" color="success">正常</a-tag>
          <a-tag v-if="scope.text.status==1" color="error">停用</a-tag>
        </span>
      </template>
      </a-table-column>
      <a-table-column key="action" title="操作" align="center" :width="360">
        <template v-slot="scope">
          <span>
            <a-button
              type="link"
              @click="edit(scope.record)"
              v-if="isShowBtn('sys:schedule:update')"
            >
              修改
            </a-button>
            <a-button
              type="link"
              @click="del([scope.record.jobId])"
              v-if="isShowBtn('sys:schedule:delete')"
            >
              删除
            </a-button>
            <a-button
              type="link"
              @click="pause([scope.record.jobId])"
              v-if="isShowBtn('sys:schedule:pause')"
            >
              暂停
            </a-button>
            <a-button
              type="link"
              @click="resume([scope.record.jobId])"
              v-if="isShowBtn('sys:schedule:resume')"
            >
              恢复
            </a-button>
            <a-button
              type="link"
              @click="run([scope.text.jobId])"
              v-if="isShowBtn('sys:schedule:run')"
            >
              立即执行
            </a-button>
          </span>
        </template>
      </a-table-column>
      
    </a-table>
    <a-pagination 
    @show-size-change="setlimit"
    @change="set_page"
    show-size-changer 
    show-quick-jumper 
    v-model:current="page" 
    v-model:page-size="limit" 
    :page-size-options="['5','10','30']" 
    :total="total"
    :show-total="total=>'共有'+total+'条任务'"
    style="float:right;margin-top:10px"
    >
      </a-pagination>
  </div>
      <Info :info="info" ref="schdialog"/>
      <Log :log="log"/>
</template>
<script>
import Info from "./info.vue"
import Log from "./log.vue"
import { isShowBtn } from "@/until/tool";
import { mapActions, mapGetters,mapMutations } from 'vuex';
import {deleteSchedule,runSchedule,pauseSchedule,resumeSchedule} from "@/api/schedule"
import { createVNode, nextTick } from "vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { message, Modal, notification } from "ant-design-vue";

export default {
  name: '',
  props: {},
  data() {
    return {
      info:{
        isAdd:true,
        isShow:false
      },
      log:{
        islog:false,
      },
      searchform:{
        page:1,
        limit:10,
        beanName:''
      },
      selectedRowKeys:[]
    };
  },
  created(){
    this.QuerySchedulePage()
  },
  computed: {
    ...mapGetters({
      page:"schedule/page",
      limit:"schedule/limit",
      beanName:"schedule/beanName",
      schedulelist:"schedule/schedulelist",
      total:"schedule/total",
    }),
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {

          this.selectedRowKeys = selectedRowKeys;
        },
        getCheckboxProps: record => ({
          props: {
            disabled: record.name === "Disabled User", // Column configuration not to be checked
            name: record.name
          }
        })
      };
    }
  },
  watch: {},
  methods: {
    isShowBtn,
    ...mapMutations({
            SET_PAGE:"schedule/SET_PAGE"
        }),
    ...mapActions({
      QuerySchedulePage:"schedule/QuerySchedulePage",
      SearchSchedule:"schedule/SearchSchedule",
      set_page:"schedule/set_page",
      set_limit:"schedule/set_limit",
    }),
    setlimit(data1,data2){
      this.set_limit({data1,data2})
    },
    onSearch(){
      this.SearchSchedule(this.searchform)
    },
    reset(){
      this.QuerySchedulePage()
    },
    toLog(){
      this.log.islog=true
    },
    toAdd(){
      this.info.isAdd = true
      this.info.isShow = true
    },
    edit(val){
      this.info.isAdd = false
      this.info.isShow = true
      this.$refs.schdialog.setinfo(val)
    },
    del(val){
      const self = this;
      Modal.confirm({
        title: "确认删除",
        icon: createVNode(ExclamationCircleOutlined),
        content: "删除操作不可撤销，请谨慎操作。",
        okText: "确定",
        cancelText: "取消",
        async onOk() {
          await deleteSchedule(val)
            .then(res => {
              if (res.code === 0) {
                notification["success"]({
                  message: "已删除"
                });
                // 如果本页只有1条数据！且不是第1页！
                if(self.schedulelist.length==1 && self.page!=1){
                    self.SET_PAGE(self.page-1)
                }
                self.QuerySchedulePage()
              } else {
                self.$message.error(res.msg);
              }
            })
            .catch(err => {
              self.$message.error(err);
            });
        }
      });
    },
    run(val){
      runSchedule(val).then((res)=>{
        if(res.code == 0){
          message.success('任务执行成功')
          this.QuerySchedulePage()
        }else{
          message.error('任务执行失败')
          this.QuerySchedulePage()
        }
      }).catch((err)=>{
        this.$handleErr(err);
      })
    },
    resume(val){
      resumeSchedule(val).then((res)=>{
        if(res.code == 0){
          message.success('任务已恢复')
          this.QuerySchedulePage()
        }else{
          message.error(res.msg)
          this.QuerySchedulePage()
        }
      }).catch((err)=>{
          this.$handleErr(err)
      })
    },
    pause(val){
      pauseSchedule(val).then((res)=>{
        if(res.code == 0){
          message.success('任务已暂停') 
          this.QuerySchedulePage()
        }else{
          message.error(res.msg)
          this.QuerySchedulePage()
        }
      }).catch((err)=>{
          this.$handleErr(err)
      })
    }
  },
  components: {
    Info,
    Log,
    ExclamationCircleOutlined
  },
  filters: {}
};
</script>
<style lang='scss' scoped>
.btnMargin {
  margin-right: 10px;
}
</style>